import axios from 'axios'

console.log(process.env)

let baseUrl = ''
if(process.env.NODE_ENV == 'development'){
  baseUrl = '/dev'
}

const service = axios.create({
  baseURL: baseUrl,
  timeout: 50000
})


service.interceptors.response.use(response => {
  if (Number(response.data.code) !== 200) {
    console.log('error')
  }
  return response
}, error => {
  return Promise.reject(error)
})

export default service
